import type { ApiClient } from "./client.js";

/**
 * Mirrors `Capabilities` (apps/server/src/capabilities.ts). Not imported
 * from there for the same reason as `SuggestField` (see items.ts): it is
 * server-internal, not part of `@skladiscenje/contracts`. The shape is
 * small and stable (it is itself a public HTTP response body), so
 * duplicating it here is low-risk, but it is still a gap worth closing by
 * moving this type into the shared contracts package.
 */
export interface Capabilities {
  dialect: "pg" | "sqlite";
  deployment: "hosted" | "desktop";
  printing: {
    silent: boolean;
    enumeratePrinters: boolean;
  };
  /**
   * Per-request LAN gate state (`apps/server/src/routes/capabilities.ts`).
   * `locked: true` means this connection is a desktop LAN device that has not
   * yet entered the shared passphrase — the SPA shows the unlock screen. The
   * till (loopback) and the hosted deployment are never locked. Optional so a
   * server that predates this field reads as "not locked".
   */
  lan?: { locked: boolean };
}

export function getCapabilities(client: ApiClient): Promise<Capabilities> {
  return client.get<Capabilities>("/api/capabilities");
}
